<template>
  <CreateDialog
    :loading="loading"
    :value="value"
    fullscreen
    @input="$emit('input', $event)"
    @reject="onReject"
    @success="onSuccess"
  >
    <template #title> {{ isEdition ? "Edit" : "Create" }} Contact </template>
    <v-card-text>
      <v-form ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-card>
                <v-card-title class="primary white--text"> Student's Generals </v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="crud.full_name"
                    label="Student's Name"
                    :rules="[rules.required]"
                    append-icon="mdi-account-box"
                  />
                  <v-text-field
                    v-model="crud.email"
                    label="Email"
                    append-icon="mdi-email"
                    :rules="[rules.required, rules.email]"
                  />
                  <phone-text-field v-model="crud.phone" label="Phone" append-icon="mdi-phone" />
                  <v-text-field
                    v-model="crud.location"
                    label="Location"
                    clearable
                    append-icon="mdi-map-marker"
                  />
                  <v-autocomplete
                    v-model="crud.nationality"
                    label="Nationality"
                    :items="countries"
                    item-text="name"
                    item-value="name"
                    clearable
                    append-icon="mdi-flag"
                  />
                  <v-text-field
                    v-model="crud.marketing_source"
                    append-icon="mdi-comment-account-outline"
                    clearable
                    label="Marketing Source"
                  />
                  <v-select
                    v-model="crud.status"
                    label="Status"
                    append-icon="mdi-list-status"
                    :items="statusItems"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-card>
                <v-card-title class="primary white--text"> Academics </v-card-title>
                <v-card-text>
                  <DatePicker v-model="crud.appointment" label="Appointment Date" />
                  <v-select
                    v-model="crud.starting_level"
                    :items="levels"
                    label="Starting Level"
                    append-icon="mdi-decagram-outline"
                  />
                  <v-text-field
                    v-model="crud.availability_text"
                    label="Availability"
                    append-icon="mdi-calendar-search"
                    rows="3"
                  />
                  <v-text-field
                    v-model="crud.program"
                    label="Program"
                    append-icon="mdi-decagram-outline"
                  />
                  <v-text-field
                    v-model="crud.teacher"
                    label="Teacher"
                    append-icon="mdi-human-male-board"
                  />
                  <v-text-field
                    v-model="crud.leveling_test_data.schedule"
                    label="Schedule"
                    append-icon="mdi-calendar-clock"
                  />
                  <DatePicker
                    clearable
                    v-model="crud.leveling_test_data.starting_date"
                    label="Starting Date"
                    append-icon="mdi-calendar-clock"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-card>
                <v-card-title class="primary white--text"> Observations </v-card-title>
                <v-card-text>
                  <v-textarea
                    v-model="crud.leveling_test_data.observations"
                    label="Observations"
                    rows="16"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </CreateDialog>
</template>

<script>
import CreateDialog from "../CreateDialog.vue";
import { crudEditComposition } from "@/compositions/crudEdit";
import { contactsController, ContactMethod, ContactedType, LevelingTest } from "@/api/crm";
import { rules } from "@/mixins/rulesMixin";
import PhoneTextField from "../PhoneTextField.vue";
import { countries } from "../../utils/countries.constant";
import { levels, StatusEnum } from "../../api/crm";
import DatePicker from "../DatePicker.vue";
import { getFormattedDate } from "@/utils/functions";

export default {
  props: {
    editedItem: Object,
    value: Boolean,
  },
  components: {
    CreateDialog,
    PhoneTextField,
    DatePicker,
  },
  setup: (props, ctx) => {
    return {
      ...crudEditComposition(
        props,
        ctx,
        {
          full_name: "",
          appointment: getFormattedDate(new Date()),
          email: "",
          phone: "+1",
          contacted: false,
          contacted_type: "",
          contact_method: "",
          address: "",
          country: "",
          nationality: "",
          payed_by_other: false,
          contact_name: "",
          contact_phone: "+1",
          contact_email: "",
          marketing_source: "",
          leveling_text: "",
          location: "",
          availability_text: "",
          school: "LANGUAGE",
          status: "ACTIVE",
          program: "",
          leveling_test_data: {
            schedule: "",
            starting_date: getFormattedDate(new Date()),
            observations: "",
          },
        },
        contactsController.createOrUpdateJson,
      ),
      rules,
      countries,
    };
  },
  data() {
    return {
      contactMethods: Object.entries(ContactMethod).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      contactedType: Object.entries(ContactedType).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      levelingTest: Object.entries(LevelingTest).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      statusItems: Object.entries(StatusEnum).map(([value, text]) => ({
        text,
        value,
      })),
      levels,
    };
  },
};
</script>
